import React from "react";
import Popup from "../UI-components/Popup";

const DivWithErrorHandling = ({ showError, closeAlert, children, error: rawError }) => {
   let messageToDisplay = null;


   console.log(rawError + " raw error");


   if (rawError && typeof rawError === 'string') {
      try {
         const parsedError = JSON.parse(rawError);

         console.log(parsedError + " parsed error: " + typeof parsedError);
         if (parsedError && typeof parsedError.message === 'string') {
            const innerMessage = parsedError.message;
            const requestExceptionPrefix = "it.luxottica.mystar.util.RequestException: ";
            const startIndex = innerMessage.indexOf(requestExceptionPrefix);


            console.log(startIndex + " start index");


            if (startIndex !== -1) {
               messageToDisplay = innerMessage.substring(startIndex + requestExceptionPrefix.length);
            } else {
               messageToDisplay = innerMessage;
            }
         } else {
            messageToDisplay = rawError;
         }
      } catch (e) {
         messageToDisplay = rawError;
      }
   } else if (rawError) {
      messageToDisplay = "An unexpected error format was received.";
   }

   let linesToRender;
   if (messageToDisplay) {
      linesToRender = messageToDisplay.split("\n");
   } else {
      linesToRender = [
         "An error occurred!",
         "Please try again later or contact website's administrator"
      ];
   }

   return (
       <div>
          {showError && (
              <Popup
                  popupClass="popup-small zIndex999"
                  close={closeAlert}
                  btnName="Close"
                  handleClick={closeAlert}
              >
                 <div>
                    {linesToRender.map((str, index) => (
                        <p key={index} className={!messageToDisplay ? "error-message" : ""}>
                           {str}
                        </p>
                    ))}
                 </div>
              </Popup>
          )}
          {children}
       </div>
   );
};

export default DivWithErrorHandling;